/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselPrint_item = {
    readonly isMultiSku: boolean;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
    } | null> | null;
    readonly sortedPhotos: ReadonlyArray<{
        readonly largePath: string | null;
        readonly sortOrder: number | null;
        readonly imageSkuXrefs: ReadonlyArray<{
            readonly skuId: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "PdpRespHeroCarouselPrint_item";
};
export type PdpRespHeroCarouselPrint_item$data = PdpRespHeroCarouselPrint_item;
export type PdpRespHeroCarouselPrint_item$key = {
    readonly " $data"?: PdpRespHeroCarouselPrint_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselPrint_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "largePath",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselPrint_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMultiSku",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sortedPhotos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sortOrder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "imageSkuXrefs",
          "storageKey": null,
          "args": null,
          "concreteType": "ImageSkuXref",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "skuId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '0a0097c0f971519639f20bad8abb59bc';
export default node;
